import {userProfile$} from '../api';

export const getUserProfile = () => userProfile$?.value;
